// Fichier genere par `yarn svg:components` : ne pas modifier a la main.
// Source : public/images/school/menu/laboratories.svg
import * as React from 'react'
import type { SVGProps } from 'react'
const SvgLaboratories = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 27 27" {...props}>
    <path
      stroke="currentcolor"
      strokeLinecap="round"
      strokeWidth={2}
      d="M6.435 1h13.587M19.478 17.848H2.63"
    />
    <path
      stroke="currentcolor"
      strokeWidth={2}
      d="M17.848 1c-.181 2.899-.218 9.022 1.087 10.326C20.565 12.956 26 18.391 26 21.652c0 2.609-1.812 3.986-2.718 4.348H4.261"
    />
    <path
      stroke="currentcolor"
      strokeWidth={2}
      d="M9.152 1c.181 2.899.218 9.022-1.087 10.326C6.435 12.956 1 18.391 1 21.652 1 24.261 2.812 25.638 3.718 26h19.021"
    />
  </svg>
)
export default SvgLaboratories
